import React from "react";
import EmissionsLineChart from "../emissionsChart.js";
import ScopesDoughnut from "storybook-dashboard/dashboard/carbonComponents/scopesDoughnut.js";
import TotalEmissionsCount from "storybook-dashboard/dashboard/carbonComponents/totalEmissionsCount.js";
import EmissionsPerTurnover from "storybook-dashboard/dashboard/carbonComponents/emissionsPerTurnoverCount.js";
import { ErrorBoundary } from "storybook-dashboard/errors";

export default function SummaryTab({ projectId, refId, companyId }) {
  return (
    <ErrorBoundary>
      <div className="d-flex flex-column flex-md-row justify-content-between mb-3">
        <div className="col-sm-12 col-md-6">
          <ErrorBoundary>
            <ScopesDoughnut projectId={projectId} refId={refId} />
          </ErrorBoundary>
        </div>

        <div className="col-sm-12 col-md-6">
          <ErrorBoundary>
            <TotalEmissionsCount projectId={projectId} refId={refId} />
          </ErrorBoundary>

          {/* <ErrorBoundary>
            <EmissionsPerTurnover projectId={projectId} refId={refId} companyId={companyId.substring(0, 8)} />
          </ErrorBoundary> */}
        </div>
      </div>

      <div className="d-flex flex-column flex-md-row justify-content-between">
        <EmissionsLineChart projectId={projectId} refId={refId} title="Total emissions over time" />
        <EmissionsLineChart projectId={projectId} refId={refId} total={false} title="Total emissions per turnover" />
      </div>
    </ErrorBoundary>
  );
}
